import React from 'react';
import PropTypes from 'prop-types';
import {Responsive} from 'admin-on-rest';
import {
    TableRow,
    TableRowColumn
} from 'material-ui/Table';
import FuseTheme from "../global/theme";

const styles = {
    rowHeight: {height: '40px'},
    label: {display: 'block', fontSize: 12, color: FuseTheme.palette.lightTextColor, margin: '10px 0 5px 0'},
    icon: {height: '40px', padding: '10px', overflow: 'inherit'}
};

/**
 * Add content for saleSeq value if it does not exist (for Admin Adjustments)
 *
 * @param data
 * @return {string}
 */
const processSaleSeq = (data) => {
    if (data.type === 'admin_adjustment' || !data.sale_seq) {
        return '(None)'
    }
    return data.sale_seq
};

const TransactionTableRow = ({data}) => (
    <Responsive
        small={
            <TableRow>
                <TableRowColumn>
                    <span style={styles.label}>Date</span>
                    {data.modified_local_str}
                    <span style={styles.label}>Transaction ID</span>
                    {processSaleSeq(data)}
                    <span style={styles.label}>Reward Points</span>
                    {data.reward_points}
                    <span style={styles.label}>Type</span>
                    {data.type}<br/><br/>
                </TableRowColumn>
            </TableRow>
        }
        medium={
            <TableRow style={styles.rowHeight}>
                <TableRowColumn style={styles.rowHeight}>
                    {data.modified_local_str}
                </TableRowColumn>
                <TableRowColumn style={styles.rowHeight}>
                    {processSaleSeq(data)}
                </TableRowColumn>
                <TableRowColumn style={styles.rowHeight}>
                    {data.reward_points} ({data.type})
                </TableRowColumn>
            </TableRow>
        }
        large={
            <TableRow style={styles.rowHeight}>
                <TableRowColumn colSpan={2} style={styles.rowHeight}>
                    {data.modified_local_str}
                </TableRowColumn>
                <TableRowColumn colSpan={2} style={styles.rowHeight}>
                    {processSaleSeq(data)}
                </TableRowColumn>
                <TableRowColumn style={styles.rowHeight}>
                    {data.reward_points}
                </TableRowColumn>
                <TableRowColumn style={styles.rowHeight}>
                    {data.type}
                </TableRowColumn>
            </TableRow>
        }
    />
);

TransactionTableRow.propTypes = {
    data: PropTypes.object.isRequired,
};

TransactionTableRow.defaultProps = {
    style: {padding: 0},
};

export default TransactionTableRow;



// WEBPACK FOOTER //
// ./src/Fuse/components/TransactionTableRow.js